import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

import { readJson, safeFetch, swallowNetworkRejections } from '../portalFetch';
import { BrandWordmark } from '../../../shared/components/BrandLogo';

const API = `${process.env.REACT_APP_API_URL || 'https://recruitai.pingitright.com/api'}/portal`;

export default function InterviewThankYou() {
  const { token } = useParams();
  const location = useLocation();
  const seeded = location.state || {};
  const [info, setInfo] = useState({
    name: seeded.candidateName || '',
    job: seeded.jobTitle || '',
  });

  useEffect(() => {
    const stopOverlay = swallowNetworkRejections();
    if (!token) return () => stopOverlay();
    let cancelled = false;
    (async () => {
      try {
        const res = await safeFetch(`${API}/meeting/${token}`);
        if (!res || cancelled) return;
        const data = await readJson(res);
        if (cancelled || !data) return;
        if (!data.interview_completed) return;
        setInfo({
          name: data.candidate_name || '',
          job: data.job_title || '',
        });
      } catch (_) { /* keep seeded thank-you content */ }
    })();
    return () => {
      cancelled = true;
      stopOverlay();
    };
  }, [token]);

  const firstName = String(info.name || '').trim().split(/\s+/)[0];

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0f172a',
      color: '#e2e8f0',
      fontFamily: "'Inter', system-ui, sans-serif",
      display: 'flex',
      flexDirection: 'column',
    }}>
      <header style={{
        height: 64,
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #1e293b',
        background: 'rgba(15,23,42,0.92)',
      }}>
        <div>
          <div style={{ fontSize: 16, fontWeight: 800, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <BrandWordmark size={16} weight={800} color="inherit" /> Interview Room
          </div>
          <div style={{ fontSize: 11, color: '#94a3b8' }}>{info.job || 'AI screening interview'}</div>
        </div>
      </header>

      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
      }}>
        <div style={{
          width: '100%',
          maxWidth: 520,
          background: '#111827',
          border: '1px solid #1f2937',
          borderRadius: 20,
          padding: '44px 36px',
          textAlign: 'center',
        }}>
          <div style={{
            width: 64,
            height: 64,
            borderRadius: 99,
            margin: '0 auto 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(134,239,172,0.12)',
          }}>
            <CheckCircle size={34} color="#86efac" />
          </div>
          <div style={{
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 0.8,
            textTransform: 'uppercase',
            color: '#86efac',
            marginBottom: 10,
          }}>
            Interview complete
          </div>
          <h1 style={{ fontSize: 28, fontWeight: 800, margin: '0 0 12px' }}>
            {firstName ? `Thank you, ${firstName}` : 'Thank you'}
          </h1>
          <p style={{ color: '#94a3b8', fontSize: 15, lineHeight: 1.7, margin: '0 0 22px' }}>
            {info.job
              ? `Your interview for ${info.job} is finished. The hiring team will review your answers and reach out with next steps.`
              : 'Your interview is finished. The hiring team will review your answers and reach out with next steps.'}
          </p>
          <div style={{
            background: 'rgba(56,189,248,0.08)',
            border: '1px solid rgba(56,189,248,0.22)',
            borderRadius: 12,
            padding: '12px 16px',
            color: '#7dd3fc',
            fontSize: 13,
            lineHeight: 1.6,
          }}>
            This meeting is over. You can close this tab.
          </div>
        </div>
      </div>
    </div>
  );
}
